/* @flow */
import Entity from 'lib/Entity';

class MessageSender extends Entity {
  getName(): string {
    return this.get('name');
  }

  // TODO does API actually return null or are our test fixtures off?
  getColor(): ?string {
    return this.get('color');
  }

  // TODO does API actually return null or are our test fixtures off?
  getInitials(): ?string {
    return this.get('initials');
  }
}

export default MessageSender;



// WEBPACK FOOTER //
// ./src/entities/MessageSender.js